import React from 'react';
import NavBar from './components/NavBar';
import Search from './components/Search';

function App() {
  return (
    <div>
      <NavBar />
      <Search />
    </div>
  );
}
export default App;
